/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250415-pro1.png?v=1744712823',
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p1.png?v=1746668579",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p2.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p3.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p4.png?v=1746668623",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p5.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p6.png?v=1746668647",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p7.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p8.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/258.png?v=1747722134",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p10.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p11.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p12.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p13.png?v=1746668708",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p14.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p15.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p16.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p17.png?v=1746668722",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p18.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p19.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p20.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-p21.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-c1.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-c2.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-c3.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-c4.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-c5.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-b1.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-b2.png",
    "https://cdn.shopify.com/s/files/1/0607/0704/5513/files/20250328-b3.png",
  ];

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    loop: true,
    pagination: {
      el: ".sp-pagination0",
      clickable: true,
    },
  });

  new Swiper("#sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination1",
      clickable: true,
    },
  });
  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height() - 10;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let prods = window.product
    function getCur(){
        const color = $('#sp-color .active').attr('data-val')
        const num = $('#sp-number .active').attr('data-val')
        return prods.filter(item => item.option1 == color && item.option2 == num)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price /100 * num ).toFixed(2)
      let compare = (getCur().compare_at_price /100 * num ).toFixed(2)
      if (price > 50) {
        // $('.product-part .sp-tip').css('display', 'flex')
        $('.product-part .btn-free').css('display', 'flex')
      } else {
        // $('.product-part .sp-tip').hide()
        $('.product-part .btn-free').hide()
      }
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".product-part .price-group .sp-row span").html(`${off_font}`);
    }

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });
  let spTextList = [
    "Pink",
    "Ivory White",
    "White(Matte)",
    "Light Gray",
    "Cool White",
    "Off-white",
    "Amber",
    "Red-Brown",
    "Black",
    "Pure White",
    "Dark Gray",
    "Light Green",
    "Gray-Green",
    "Cream Cheese",
    "Blue-Gray",
    "Light Blue",
    "Chocolate Brown",
    "Mint Green",
    "Beige",
    "Cyan Color",
    "Freshwater Blue",
    "Clear Varnish",
  ];
  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $("#sp-color .sp-option.active").index();
    let _index = colorOptions;
    $(".product-part .sp-img-p")[0].src = spImgList[_index];

    $(".product-part .sp-name").text(spTextList[_index]);
    changePrice()
  });
  $('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
// 弹窗 start
   var main_id = "";
    $('.emitCheckout').click(function(){
      console.log('1111')
      main_id = getCur().id
      // main_id = $(this).siblings('.select_span').find('span.on').data('id')
      // window.location.href = "/cart/" + id + ":1"
    })

  function getPopProdId(){
    let selectVals = [];
    $(".overbuy-select input[type='radio']:checked").each(function(){
      selectVals.push($(this).val())
    })

    let cur = popProduct.filter(item => {
      let option1 = selectVals[0];
      let option2 = null;
      let option3 = null;
      if(selectVals[1]){
        option2 = selectVals[1];
      }
      if(selectVals[2]){
        option3 = selectVals[2];
      }

      
      return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
    })

 
    
    return cur[0];
  }

  $(".overbuy-select input[type='radio']").on('change',function(){
    let cur = getPopProdId();
    let _price = parseFloat(cur.price / 100).toFixed(2);
    let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);

    $('.overbuy_price span').eq(0).html('$' + _price);
    $('.overbuy_price span').eq(1).html('$' + _compare_at_price);
  })

  


  window.emitSubmit = function(_type){
    let num = $('#calcNumber').val()
     if(_type == 'all'){
      // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
      let _id = getPopProdId()?.id;
      window.location.href = `/cart/${main_id}:${num},${_id}:1`;
    }else{
      window.location.href = `/cart/${main_id}:${num}`
    }
  }


  // 弹窗 end
  $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
             $("#cardNum").removeClass("sp-gray");
          });
        },
        dataType: "json",
      });
      $("#cardNum").removeClass("sp-gray");
      // handleAddToCart(initNum);

      var img = $(".product-part .sp-img-p");
      // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        background: "#e7e9ef",
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          // top: finish[0].offsetTop,
          top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });
});
